/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Badoo - Γνώρισε νέα άτομα, κάνε chat, κάνε γνωριμίες",
      "Λανθασμένος αριθμός τηλεφώνου",
      "Get the app",
      "Συνέχεια με Apple",
      "Συνέχεια με το Facebook",
      "Συνέχεια με Google",
      "Σύνδεση",
      "Εγγραφή",
      "Για να συνεχίσεις, πληκτρολόγησε τους χαρακτήρες που βλέπεις στο παρακάτω πεδίο.",
      "Συνέχεια",
      "Πληκτρολόγησε τους χαρακτήρες",
      "Έλεγχος ασφαλείας",
      "Επαναφόρτωση",
      "Δημιούργησε έναν νέο κωδικό πρόσβασης, τον οποίο θα είναι εύκολο να απομνημονεύσεις:",
      "Ενημέρωση",
      "Επιβεβαίωση κωδικού πρόσβασης",
      "Ο κωδικός πρόσβασης πρέπει να αποτελείται από τουλάχιστον {{num}} [[characters:num]]",
      "Κωδικός πρόσβασης",
      "Δημιουργία νέου κωδικού πρόσβασης",
      "Badoo - The Blog",
      "Θέσεις εργασίας",
      "Chat",
      "Πόλεις",
      "Διαχείριση cookies",
      "Copyright © 2006 – σήμερα. Bumble. Με την επιφύλαξη παντός δικαιώματος.",
      "Το Apple και το λογότυπο Apple είναι σήματα κατατεθέντα της Apple Inc.{{__EOL__}}Το στοιχείο Google Play αποτελεί εμπορικό σήμα της Google LLC.",
      "Λήψη",
      "Facebook",
      "Ακολούθησέ μας",
      "Κέντρο βοήθειας",
      "Instagram",
      "Γλώσσα",
      "LinkedIn",
      "Ενότητες",
      "Το Badoo ανήκει στη Bumble Inc.",
      "Πολιτική απορρήτου",
      "Safety Centre",
      "Χάρτης τοποθεσίας",
      "Νόμος για τη σύγχρονη δουλεία",
      "Όροι και προϋποθέσεις",
      "Twitter",
      "Συμπλήρωσε παρακάτω το email ή τον αριθμό του κινητού σου και θα σου στείλουμε οδηγίες για τη δημιουργία νέου κωδικού πρόσβασης.",
      "Απόκτησε νέο κωδικό πρόσβασης",
      "Εισάγαγε το email ή τον αριθμό τηλεφώνου σου",
      "Ξέχασα τον κωδικό πρόσβασης",
      "Τα μοντέλα χρησιμοποιούνται μόνο για λόγους απεικόνισης",
      "Get the app",
      "We’re excited to bring renewed support, helpful technology, and safer experiences to help foster relationships formed with greater confidence. This is all part of Badoo’s commitment to being the app that builds dating confidence.",
      "We’ll continue to pioneer dating technology to meet the needs of daters as identified in this report, starting with the release of ‘<b><a href=\"{{url}}\">Deception Detector™</a></b>’, a machine learning model that has demonstrated <b>99.5% precision</b> in combating spam, scam and fake accounts.",
      "We remain <b>committed</b> to the responsible use of Artificial Intelligence (A.I.), ensuring human intelligence comes first and A.I. capabilities don’t damage the <b>authenticity</b> of our community;",
      "We’ll no longer contribute to the creation of dating trends that fuel <b>negative perceptions</b> and <b>behaviours</b>;",
      "We’ll work to identify <b>bad behaviour</b> in dating so we can minimise its impact on our community’s well-being;",
      "We’ll only work with influencer talent who we think are <b>authentic</b> and <b>realistic</b> in how they present themselves online;",
      "Take me to Badoo",
      "Our Confidence Commitments:",
      "We’ve published this report for daters, dating communities, and online platforms—anyone—to be able to use the findings to help people have a kinder, more enjoyable experience with greater possibilities than ever before.",
      "At Badoo, we know there’s work to be done. Our teams have studied findings and are making changes so we can play our part. But there are also immediate commitments we’ve decided to make.",
      "At a pivotal moment when we believe human connection has never been more valuable, and people having confidence in how they can form connections has never been more important, we have created an <b>industry first Dating Confidence Report.</b>",
      "Download the report",
      "Badoo has always been a pioneer in dating, creating one of the first online dating platforms in the world and being the first to reach 100 million downloads.",
      "The report details behaviours, attitudes and influences that have negatively influenced dating, supported by expert guidance on how we can enjoy more of the best parts—and be better equipped to manage (or change) the parts we’d all rather avoid.",
      "Being intentional: relaxing, being present, and being themselves in their dating experiences—on and offline",
      "Being able to ignore what they see on social media, and focus on what works for them;",
      "Feeling they can trust that who they’re seeing or speaking to is for real;",
      "Feeling clear in their own intentions and trusting that their matches are being genuine, too;",
      "Reducing paranoia and hypervigilance about negative dating behaviour;",
      "The key ingredients for greater dating confidence are:",
      "We believe this is the dating world’s biggest barrier to its potential—and our commitment to breaking this barrier has begun. Every year, instead of focusing on dating trends, we’ll track our own progress in building dating confidence and continue to assess the challenges daters face across the industry.",
      "The findings will lead to annual Confidence Commitments and innovations in our product to help minimise dating experiences that damage people’s confidence. Ultimately this’ll help make online dating a kinder, <b><u><a href=\"{{url}}\">safer</a></u></b> and more valuable experience for those who want meaningful connections. Our commitments for 2024 are below.",
      "Read Confidence Commitments",
      "The report shows us in no uncertain terms that dating confidence is at an all-time low for many singles.",
      "Δεν υπάρχει λόγος να περιμένεις να σε ψηφίσουν.{{__EOL__}}{{__EOL__}}.Μπορείς να στείλεις αμέσως μήνυμα και να γνωρίσεις όποιον επιθυμείς.",
      "Θες να κάνεις chat τώρα;",
      "Αν ολοκληρώσεις την εγγραφή, συμφωνείς με τους <a class=\"link\" href=\"{{terms_url}}\">Όρους και τις Προϋποθέσεις μας</a>. Μάθε πώς χρησιμοποιούμε τα δεδομένα σου στην <a class=\"link\" href=\"{{privacy_url}}\">Πολιτική Απορρήτου</a>.",
      "Μια αυθεντική εμπειρία γνωριμίων, <br />όπου μπορείς να είσαι ο εαυτός σου.",
      "Γνωριμίες με αυτοπεποίθηση.",
      "Ή",
      "Έχεις ήδη λογαριασμό;",
      "Εγγραφή μέσω email ή τηλεφώνου",
      "Κάνε τις γνωριμίες που επιθυμείς.{{__EOL__}}Χωρίς εξηγήσεις.",
      "Θες απλά να κάνεις chat; Κανένα πρόβλημα.{{__EOL__}}Θες να βρεις κάτι σταθερό; Τέλεια!{{__EOL__}}{{__EOL__}}Κι αν στο μεταξύ αλλάξεις γνώμη, μπορείς!",
      "Είμαι εδώ για γνωριμίες",
      "Έτοιμοι για σχέση",
      "Με διάθεση για chat",
      "Γνώρισε άτομα που θέλουν τα ίδια πράγματα.",
      "{{name}}, {{age}}",
      "Η ασφάλειά σου είναι νούμερο 1 προτεραιότητα.",
      "Το Κέντρο ασφαλείας είναι ένας κόμβος γνώσης, για να έχεις όση υποστήριξη χρειάζεσαι ώστε να κάνεις γνωριμίες με αυτοπεποίθηση.",
      "Επισκέψου το Κέντρο ασφαλείας",
      "Πριν και πάνω απ' όλα<br/>είναι η ασφάλεια.",
      "Από την πρώτη στιγμή ήξερα ότι θα πάει καλά...",
      "Στην αρχή δεν έψαχνα κάτι σοβαρό…",
      "Μια συμβουλή σε όλους στο Badoo: Να είστε ο εαυτός σας...",
      "Ιστορίες επιτυχίας του Badoo",
      "Δες περισσότερες ιστορίες επιτυχίας",
      "{{num}}__CUT__Βαθμολογία",
      "Apple App Store",
      "Εμπιστέψου μας. Έχουμε φέρει εκατομμύρια των εκατομμυρίων άτομα κοντά από το 2006.",
      "{{num}} εκατ. +__CUT__Λήψεις",
      "{{num}} εκατ. +",
      "Google Play Store",
      "Ξέρουμε τι κάνουμε.",
      "Σύνδεση μέσω email ή τηλεφώνου",
      "Εισάγαγε τον κωδικό πρόσβασής σου",
      "Ξέχασες τον κωδικό πρόσβασης;",
      "Εγγραφή",
      "Δεν έχεις λογαριασμό;",
      "Σύνδεση",
      "Εγγραφή"
],

    // These are the common words found in the lexemes of the app
    common: {
      "characters": {
            "plural": [
                  "χαρακτήρες",
                  "χαρακτήρων",
                  "χαρακτήρες"
            ],
            "singular": [
                  "χαρακτήρας",
                  "χαρακτήρα",
                  "χαρακτήρα"
            ]
      },
      "day": {
            "plural": [
                  "ημέρες",
                  "ημερών",
                  "ημέρες"
            ],
            "singular": [
                  "ημέρα",
                  "ημέρας",
                  "ημέρα"
            ]
      },
      "hour": {
            "plural": [
                  "ώρες",
                  "ωρών",
                  "ώρες"
            ],
            "singular": [
                  "ώρα",
                  "ώρας",
                  "ώρα"
            ]
      },
      "minute": {
            "plural": [
                  "λεπτά",
                  "λεπτών",
                  "λεπτά"
            ],
            "singular": [
                  "λεπτό",
                  "λεπτού",
                  "λεπτό"
            ]
      },
      "month": {
            "plural": [
                  "μήνες",
                  "μηνών",
                  "μήνες"
            ],
            "singular": [
                  "μήνας",
                  "μήνα",
                  "μήνα"
            ]
      },
      "second": {
            "plural": [
                  "δεύτερα",
                  "δεύτερων",
                  "δεύτερα"
            ],
            "singular": [
                  "δεύτερο",
                  "δεύτερου",
                  "δεύτερο"
            ]
      },
      "year": {
            "plural": [
                  "χρόνια",
                  "χρόνων",
                  "χρόνια"
            ],
            "singular": [
                  "χρόνος",
                  "χρόνου",
                  "χρόνο"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
